import React from 'react'
import { ICellRendererParams } from 'ag-grid-community'

const CHECKBOX_EDIT_SOURCE = 'checkboxRenderer'

const isDraftRow = (data: unknown): boolean => {
  if (!data || typeof data !== 'object') return false
  const id = (data as Record<string, unknown>).id
  return typeof id === 'string' && id.startsWith('new-')
}

const toBoolean = (value: unknown): boolean => {
  if (typeof value === 'boolean') return value
  if (typeof value === 'string') return value === 'true'
  if (typeof value === 'number') return value === 1
  return false
}

export function CheckboxCellRenderer(props: ICellRendererParams) {
  if (isDraftRow(props.data)) return null

  const checked = toBoolean(props.value)
  const isEditable = props.column?.isCellEditable?.(props.node) ?? false

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation()
    if (!isEditable) return

    const field = props.colDef?.field
    if (typeof field !== 'string') return

    const newValue = (!checked).toString()

    if (props.setValue) {
      props.setValue(newValue)
      return
    }

    if (props.node) {
      // Use per-cell updates (not transactions) to keep grid stacks intact.
      props.node.setDataValue(field, newValue, CHECKBOX_EDIT_SOURCE)
      return
    }
  }

  return (
    <div className="flex h-full items-center justify-center">
      <input
        type="checkbox"
        checked={checked}
        disabled={!isEditable}
        onClick={(event) => event.stopPropagation()}
        onChange={handleChange}
        className="size-4 rounded border-gray-300 text-slate-500 focus:ring-primary-500"
      />
    </div>
  )
}
